"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynchronizerAction = void 0;
class SynchronizerAction {
    constructor(controller, type, id, params, mergeMode = "extend") {
        this.params = params;
        this.id = id;
        this.type = type;
        this.controller = controller.getId();
        this.mergeMode = mergeMode;
    }
    getUuid() {
        return this.controller + "/" + this.type + "/" + this.id;
    }
    merge(action) {
        if (!action) {
            return this;
        }
        if (this.mergeMode === "extend") {
            this.params = Object.assign(Object.assign({}, action.params), this.params);
        }
        else if (this.mergeMode === "concat") {
            this.params = action.params.concat(this.params);
        }
        return this;
    }
    export() {
        return {
            params: this.params,
            id: this.id,
            type: this.type,
            controller: this.controller,
            uuid: this.getUuid(),
        };
    }
}
exports.SynchronizerAction = SynchronizerAction;
//# sourceMappingURL=synchronizercontroller.js.map